const $ = require('jquery');
const modal = require('./modal.js');
const pjax = require('./pjax.js');

module.exports = {
  enableDropdown() {
    $(document).on('click', '[data-toggle="#header-drop"]', function (e) {
      e.preventDefault();
      const toggle_target = $(this).data('toggle');
      $(toggle_target).toggleClass('is-hidden');
    });
    $('body').on('click', (e) => {
      if ($(e.target).closest('[data-toggle="#header-drop"]').length > 0) {
        return 0;
      }
      $('#header-drop').addClass('is-hidden');
      return 1;
    });
  },
  handleMemberMenuActionConfirm() {
    $(document).on('click', '.memberMenu [data-confirm]', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const $target = $(this);
      let msg = $(this).data('confirmMsg');
      if (typeof msg === 'undefined') {
        msg = '';
      }
      const dontHide = $(this).data('confirm-dont-hide');

      const callback = function (result) {
        if (result) {
          $.post($target.data('href'));

          if (dontHide) {
            $target.closest('.member').addClass('loading');
          } else {
            $target.closest('.member').addClass('hide');
          }
        }
      };
      modal.confirm(msg, callback);
    });
  },
  handleProfileActionConfirm() {
    $(document).on('click', '.profile [data-confirm]', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const $target = $(this);
      let msg = $(this).data('confirmMsg');
      if (typeof msg === 'undefined') {
        msg = '';
      }
      const callback = function (result) {
        if (result) {
          $.pjax({ url: $target.data('href'), container: $target.data('confirm-target') });
        }
      };
      modal.confirm(msg, callback);
    });
  },
  handleCommentActionConfirm() {
    $(document).on('click', '.discussionComment-action [data-confirm]', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const $target = $(this);
      let msg = $(this).data('confirmMsg');
      if (typeof msg === 'undefined') {
        msg = '';
      }
      const callback = function (result) {
        if (result) {
          $.pjax({ url: $target.data('href'), container: $target.data('confirm-target') });
        }
      };
      modal.confirm(msg, callback);
    });
  },
  init() {
    module.exports.enableDropdown();
    this.handleMemberMenuActionConfirm();
    this.handleProfileActionConfirm();
    this.handleCommentActionConfirm();

    // pievieno aktīvo klasi, ja uzspiests uz menu, lai nebūtu jāpārlādē header
    $(document).on('pjax:end', () => {
      if (typeof globals.active_menu === 'undefined' || globals.active_menu.length < 1) {
        return;
      }

      const pathname = window.location.pathname;
      const path_parts = pathname.split('/');
      let name_index = 0;
      if (typeof globals.webroot !== 'undefined') {
        name_index += globals.webroot.split('/').length;
      }

      if ((path_parts[name_index] == globals.active_menu.data('name'))
        || (path_parts[name_index + 1] == globals.active_menu.data('name'))
        || (path_parts[name_index] == globals.active_menu.data('alt-name'))
        || (path_parts[name_index + 1] == globals.active_menu.data('alt-name'))
      ) {
        globals.active_menu.addClass('is-active');
        globals.active_menu.siblings('.menu-item').removeClass('is-active');
        return;
      }

      globals.active_menu.removeClass('is-active');
      globals.active_menu.siblings('.menu-item').removeClass('is-active');
      globals.active_menu = [];
    });
  },
  disableDropdown() {
    $(document).off('click', '[data-toggle="#header-drop"]');
    $('body').off('click');
  },
};
